import { Component, OnInit, ViewChild, ElementRef, Renderer2, OnDestroy, ChangeDetectorRef, AfterViewInit, Input, Optional } from '@angular/core';
import { ENTER, CONTROL } from '@angular/cdk/keycodes';
import { HttpServerService } from '../../../customer-service/http.server.service';
import _ from 'lodash';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ServerService } from '../../../customer-service/server.service';
import { tap, takeUntil, debounceTime, first, skip } from 'rxjs/operators';
import { Subject, fromEvent } from 'rxjs';
import { SystemService } from '@root/router/system/system.service';
import { StoreService } from '@root/shared/service/store.service';
import { TranslateService } from '@root/shared/service/translate.service';
import { InternationalService } from '@root/international.service';
import { AppService } from '@root/app.service';
@Component({
  selector: 'host-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('container', { static: true }) container: ElementRef;
  @ViewChild('chatInput', { static: true }) chatInput: ElementRef;
  @Input() visitToken;
  @Input() displayVisitForm = false;
  @Input() entry;
  @Input() pure = false; // 是否纯的客户端。位于应用内的客户端具有用户状态，需要整体的交互，为非纯的客户端。官网和登录页的客户端只需要纯粹的聊天功能，为纯的客户端。
  // get entry () { return this._entry }; // 入口
  // set entry (value) {
  //   /**
  //    * 官网，登录，以及应用内三个地方公用这一个组件
  //    * 需要识别入口并上报，且同一个生命周期内只需上报一次
  //    *
  //    * 官网通过postMessage的方式实现不同站点的数据交流
  //    * 登录和应用内都是通过直接传值的方式
  //    *
  //    * 官网的entry的获取是异步的，而登录和应用内是同步的，所以为了实现上报逻辑的统一，将entry的默认值设为null
  //    * 当entry不为空的时候开始上报，可以保证entry都是正确被传递过来的
  //    */
  //   console.log('before entry: ', this._entry);
  //   this._entry = value;
  //   if (value) {
  //     this.contact();
  //     // this.reported = true;
  //     console.log('entry value: ', value);
  //   }
  // }
  visitForm = {
    mobile: null,
    email: null,
    address: null
  };
  listOfMessage = [];
  host = null;
  admin = null;
  inputValue;
  private readonly visitFormKey = 'hostex_fill_in_visit_form';
  private readonly visitFormValueKey = 'hostex_fill_in_visit_form_value';
  private readonly pageSize = 100;
  private fetchComplete = false;
  // private reported = false;
  lastScrollHeight = 0;
  scrollBottom = 0;
  dragState;
  private appendMessage$ = this.customerService.appendClientMessage$.pipe(
    tap(value => {
      console.log('value from server: ', value);
      this.fetchMessageList();
      this.markRead();
    })
  );

  /** 应用外部的客服初始化延迟到这里执行 */
  private initEntry$ = this.customerService.updateClientEntry$.pipe(
    first(),
    tap(entry => {
      console.log('first entry change: ', entry);
      this.entry = entry;
      this.init();
    })
  );
  /** 应用外部的客服更新 */
  private updateEntry$ = this.customerService.updateClientEntry$.pipe(
    skip(1),
    tap(entry => {
      console.log('entry change: ', entry);
      /**
       * 用于监听entry的变化，主要用于处理官网的entry
       * 应用内的client每次都会重新初始化，所以不存在entry的变化
       */
      this.entry = entry;
      this.contact().subscribe(res => {
        this.fetchMessageList();
      });
      // this.updateChat();
      // this.fetchMessageDetail();
    })
  )
  private destroy$ = new Subject();

  trackById = msg => msg.msg_id;
  get isInternational() {
    // return this.international.isInternational()
    return this.app.app.international;
  }

  constructor(
    private httpService: HttpServerService,
    private customerService: ServerService,
    private systemService: SystemService,
    private render: Renderer2,
    @Optional() private modalRef: NzModalRef,
    private storeService: StoreService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    // private international: InternationalService,
    private app: AppService
  ) {
    this.appendMessage$.pipe(takeUntil(this.destroy$)).subscribe();
    this.initEntry$.pipe(takeUntil(this.destroy$)).subscribe();
    this.updateEntry$.pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnInit() {
    /**
     * entry 不为空，说明位于应用内，直接初始化
     * entry 为空，说明位于应用外，不执行初始化，初始化的操作延迟到 customerService.updateClientEntry
     */
    if (this.entry) {
      this.init();
    }
  }
  private init () {
    if (this.visitToken && this.isInternational) {
      this.checkIsFillInVisitForm();
    } else {
      this.initRequest();
    }
  }

  /**
   * @TODO contact和updateChat改成同步，以免detail比contact和updateChate执行的快的问题
   */
  private initRequest() {
    /** contact为入口信息，需确保其在获取聊天内容之前调用 */
    this.contact().subscribe(res => {
      // this.updateChat();
      this.fetchMessageDetail();
      this.updateChat();
      this.markRead();
    });

  }

  private checkIsFillInVisitForm() {
    // const isFilled = this.storeService.get(this.visitFormKey, 2);
    /** 匿名用户要始终展示信息采集框 */
    const isFilled = false;
    if (isFilled) {
      // this.init();
    } else {
      this.displayVisitForm = true;
      const value = this.storeService.get(this.visitFormValueKey, 2);
      if (value) {
        this.visitForm = value;
      }
    }
  }

  ngAfterViewInit() {

    fromEvent(this.container.nativeElement, 'scroll').pipe(
      tap((event: Event) => {
        const target = event.target as HTMLElement;
        // console.log('target: ', event, ' scrollHeight: ', target.scrollHeight, ' scrollTop: ', target.scrollTop, ' clientHiehgt: ', target.clientHeight);
        this.lastScrollHeight = target.scrollHeight;

        this.scrollBottom = target.scrollHeight - target.scrollTop;
        if (target.scrollTop <= 0 && !this.fetchComplete) {
          // console.log('herererer');
          this.fetchMessageList(true);
        }
      }),
      debounceTime(300),
      takeUntil(this.destroy$)
    ).subscribe();

    setTimeout(() => {
      const chatbox = this.chatInput && this.chatInput.nativeElement;
      chatbox && chatbox.focus();
    }, 300);
  }
  scrollToBottom() {
    const container = this.container.nativeElement;
    this.render.setProperty(container, 'scrollTop', container.scrollHeight);
  }

  contact() {
    return this.httpService.contact({ entry: this.entry || 'web-客服' });
  }

  updateChat() {
    const device = this.getOSInfo();
    this.httpService.updateChat({ device }).subscribe();
  }

  reportVisitInfo() {
    const params = {
      name: this.visitToken,
      ...this.visitForm
    };
    this.httpService.reportVisitInfo(params).subscribe(res => {
      if (res.error_code === 0) {
        this.displayVisitForm = false;
        this.storeService.set(this.visitFormKey, true, 2);
        /** 将填写的值存储到本地，下次打开时如果有值，则用该值填充 */
        this.storeService.set(this.visitFormValueKey, this.visitForm, 2);
        this.initRequest();
      }
    });
  }

  fetchMessageDetail() {
    this.httpService.fetchChatDetail({}).subscribe(res => {
      ////////// @deprecated
      // const messages = _.get(res, 'data.detail.messages') || [];
      // this.listOfMessage = _.reverse(messages);
      ////////// @deprecated
      // const users = _.get(res, 'data.detail.users');
      // this.host = _.find(users, { role: 'host' });
      // this.admin = _.find(users, { role: 'admin' });

      this.host = _.get(res, 'data.detail.host');
      this.admin = _.get(res, 'data.detail.admin');

      this.fetchMessageList();
      // this.cdr && this.cdr.detectChanges();
      // setTimeout(() => {
      //   this.scrollToBottom();
      // }, 500)
    });
  }

  fetchMessageList(loadMore = false) {

    const params = {
      page_size: this.pageSize
    };
    if (loadMore) {
      const lastMessage = _.head(this.listOfMessage);
      _.assign(params, {
        msgid: lastMessage.msg_id,
        timestamp: lastMessage.timestamp
      });
    }

    this.httpService.fetchMessageList(params).subscribe(res => {
      const messages = _.get(res, 'data.messages') || [];
      const reversed = _.reverse(messages);

      if (messages.length < this.pageSize) {
        this.fetchComplete = true;
      } else {
        this.fetchComplete = false;
      }

      if (!loadMore) {
        this.listOfMessage = reversed;
        setTimeout(() => {
          this.scrollToBottom();
        }, 300)
      } else {
        this.listOfMessage = _.concat(reversed, this.listOfMessage);
        setTimeout(() => {
          const e = this.container.nativeElement;
          // e.scrollTop = e.scrollHeight - this.lastScrollHeight;
          e.scrollTop = e.scrollHeight - this.scrollBottom;
        }, 0);
      }

      this.cdr && this.cdr.detectChanges();
    });
  }

  markRead() {
    this.httpService.read().subscribe(() => {
      if (!this.pure) {
        /** 更新未读数量 */
        this.systemService.fetchCustomerServiceInfo();
      }
    });
  }
  sendMessage(data) {
    console.log('send: ', data);

    const msgId = Math.random();
    this.appendLocalMessage(msgId, data.type, data.content);
    setTimeout(() => {
      this.scrollToBottom();
    }, 300)

    this.httpService.sendMessage({
      type: data.type,
      content: data.content,
    }).subscribe(res => {
      if (res.error_code === 0) {
        _.delay(() => {
          this.fetchMessageList();
        }, 500);
      } else {
        this.updateLocalMessage(msgId, {
          // errorMsg: `发送失败，失败原因${res.error_msg}`
          errorMsg: this.translate.syncGet('customer_service.send_failed', { error: res.error_msg })
        });
      }
    });
  }
  onKeyDown(event: KeyboardEvent) {
    const ctrlKey = event.ctrlKey;
    const keyCode = event.keyCode;
    if (ctrlKey && keyCode === ENTER) {
      event.preventDefault();
      /** 换行 */
      this.inputValue = `${this.inputValue}\n`;
    } else if (keyCode === ENTER) {
      /** 发送 */
      event.preventDefault();
      this.sendTextMessage();
    }
  }
  onUploadChange(e) {
    const file = e.file;

    if (file.status === 'done') {
      const url = _.get(file, 'response.data.file.original_url');
      this.sendImageMessage(url);
    }
  }

  sendTextMessage() {
    if (!this.inputValue && this.inputValue !== 0) {
      return;
    }
    this.sendMessage({ type: 'text', content: this.inputValue });
    this.clearInput();
  }

  sendImageMessage(url) {
    this.sendMessage({ type: 'image', content: url });
  }

  clearInput() {
    this.inputValue = null;
  }

  close() {
    this.modalRef && this.modalRef.close();
  }

  onDragOver(event) {
    event.stopPropagation();
    event.preventDefault();
    this.dragState = event.type;
    console.log('drag 0ver');
  }

  onDragLeave(event) {
    this.dragState = event.type;
    console.log('drag leave ...');
  }

  onDrop(event) {
    event.preventDefault();
    this.dragState = event.type;

    const items = event.dataTransfer.items;
    _.forEach(items, (item, i) => {
      if (item.kind === 'file') {
        const file = item.getAsFile();

        const formData = new FormData();
        formData.append('file', file);

        this.httpService.upload(formData).subscribe(res => {
          console.log('res: ', res)
          const url = _.get(res, 'data.file.original_url');
          this.sendImageMessage(url);
        });

      }
    });
  }

  private appendLocalMessage(msgId, type, content) {
    this.listOfMessage.push({
      msg_id: msgId,
      from: this.host.id,
      message: {
        type,
        content,
        extra: null
      }
    });
  }

  private updateLocalMessage(msgId, data) {
    const msg = _.findLast(this.listOfMessage, { msg_id: msgId });

    if (msg) {
      _.assign(msg, data);
    }
  }

  private getOSInfo() {
    let name = 'unknown';
    let browser = 'unknown';
    const app = 'Hostex Web 2.7.0';

    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('win') !== -1) {
      name = 'windows';
    } else if (userAgent.indexOf('mac') !== -1) {
      name = 'macOS';
    } else if (userAgent.indexOf('linux') !== -1) {
      name = 'linux';
    }

    if (userAgent.indexOf('edg') !== -1) {
      browser = 'Edge';
    } else if (userAgent.indexOf('firefox') !== -1) {
      browser = 'Firefox';
    } else if (userAgent.indexOf('chrome')) {
      browser = 'Chrome';
    } else if (userAgent.indexOf('safari')) {
      browser = 'Safari';
    }

    return `${name}-${browser}-${app}`;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
